import React, { useState, useEffect }              from 'react';
import ResiFormLayout                   from '../../../components/ResiFormLayout';
import CustomTextFieldAggiungi          from '../../../components/fields/CustomTextFieldAggiungi';
import CustomNoteAggiungi               from '../../../components/fields/CustomNoteAggiungi';
import CustomDragAndDrop                from '../../../components/fields/CustomDragAndDrop';
import MerceNonConforme                 from '../../../images/MerceNonConformePng.png';
import { useNavigate }                  from 'react-router-dom';
import CustomAutocomplete               from '../../../components/fields/CustomAutocomplete';
import CustomDatePickerAggiungi         from '../../../components/fields/CustomDatePickerAggiungi';
import axios                            from 'axios';
import { useTranslation }               from 'react-i18next';
import SendEmail                        from '../../../components/SendEmail';
import SendAvviso                       from '../../../components/SendAvviso';
import dayjs                            from 'dayjs';
import CircularProgressWithLabel        from '../../../components/CircularProgressWithLabel';
import CustomNumberAggiunta             from '../../../components/fields/CustomNumberAggiunta';
import AddCircleIcon                    from "@mui/icons-material/AddCircle";
import RemoveCircleIcon                 from "@mui/icons-material/RemoveCircle";
import CustomNumber2                    from '../../../components/fields/CustomNumber2';
import CustomTextFieldAggiungi2         from '../../../components/fields/CustomTextFieldAggiungi2';
import { 
    Grid, 
    Button, 
    Box, 
    Typography, 
    Alert,
    Radio, 
    RadioGroup, 
    FormControlLabel, 
    FormControl, 
    FormLabel,
    IconButton,
    TextField
} from '@mui/material';
import ApiService from '../../../components/service/ApiService';


const MerceNonConformeForm = () => {
    const navigate = useNavigate();
    const {t} = useTranslation();
    const [formValues, setFormValues] = useState({
        numeroFattura: '',
        dataRicezione: '',
        quantita: '1',
        infoProblema: '',
        tipologia: 'ANOMALIA_MERCE_NON_CONFORME',
        numeroFatturaReal: '',
        dataCreazioneRMA: dayjs().format('DD/MM/YYYY'),
        richiestaIndirizzo: false,
        descrizione: null,
        compagniaTrasporto: null,
        infoAggiuntive: null,
        dataFattura: null,
        skuEan: null,
        imeiSerial: null,
        stato: null,
        id: null,
        dannoFisico: null,
        idReso: null,
        numeroFatturaClienteFinale: null,
        merceFirmataRiserva: null,
        dataRicezioneMerce: '',
        dataFatturaClienteFinale: null,
        possessoResocontoTecnico: null,
        prodotti: [{ skuEan: '', descrizione: '', quantita: '', imeiSerial: '' }]
    });
    
    const [alert,                       setAlert                    ] = useState({ open: false, message: '', severity: 'success' });
    const [errors,                      setErrors                   ] = useState({});
    const [uploadedFiles,               setUploadedFiles            ] = useState([]);
    const [loading,                     setLoading                  ] = useState(false);
    const [progress,                    setProgress                 ] = useState(0);
    const [step,                        setStep                     ] = useState(1);
    const [message,                     setMessage                  ] = useState('');
    const [snackbarSeverity,            setSnackbarSeverity         ] = useState('success');
    const [fattureOptions,              setFattureOptions           ] = useState([]);
    const [skuOptions,                  setSkuOptions               ] = useState([]);
    const [skuDetails,                  setSkuDetails               ] = useState([]);
    const [dataFattura,                 setDataFattura              ] = useState([]);
    const [maxQty,                      setMaxQty                   ] = useState(1);
    const [isDataRicezioneEnabled,      setIsDataRicezioneEnabled   ] = useState(false);
    const [radioValue,                  setRadioValue               ] = useState('nonRicevuta');
    const [isFatturaSelected,           setIsFatturaSelected        ] = useState(false);
    const [isFetchingFatturaDetails,    setIsFetchingFatturaDetails ] = useState(false);

    const [products,            setProducts         ] = useState([
        { skuEan: '', descrizione: '', imeiSerial: '', quantita: '' }
    ]);    

    const user = JSON.parse(sessionStorage.getItem("user"));
    const token = user?.token;
    const headers = {
        Authorization: `Bearer ${token}`
    };
    const idCliente = user?.idCliente;  
    const ragioneSociale = user?.ragioneSociale;
    const id = user?.IDCustomerRMT;
    const IDCustomerRMT = user?.idRiba;

    const fetchFatture = async () => {
        setLoading(true);
        try {
            // const response = await axios.get(`http://localhost:8080/cliente/riba/fatture/${id}`, { headers: headers });
            const response = await ApiService.request("getFatture", { id: id});
            
            
            // if (response.data?.code === 200 && Array.isArray(response.data.result)) {
            //     const fattureOptions = response.data.result.map((fattura) => {
            //         const formattedDate = dayjs(fattura.DateInvoice, "YYYYMMDD").format("DD/MM/YYYY");
                    
            //         return {
            //             label: `${fattura.InvoiceNr} - ${formattedDate}`,
            //             value: fattura.InternalIDInvoice, 
            //         };
            //     }).reverse();
            if (response.data?.code === 200 && Array.isArray(response.data.result)) {
                const today = dayjs(); 
                const oneMonthAgo = today.subtract(1, "month"); 
                
                const fattureOptions = response.data.result
                    .filter((fattura) => {
                        const fatturaDate = dayjs(fattura.DateInvoice, "YYYYMMDD");
                        return fatturaDate.isAfter(oneMonthAgo); 
                    })
                    .map((fattura) => {
                        const formattedDate = dayjs(fattura.DateInvoice, "YYYYMMDD").format("DD/MM/YYYY");
                        return {
                            label: `${fattura.InvoiceNr} - ${formattedDate}`,
                            value: fattura.InternalIDInvoice, 
                        };
                    })
                    .reverse();
                
                setFattureOptions(fattureOptions);
            } else {
                console.error("La risposta non contiene un array valido in `result`:", response.data);
            }
        } catch (error) {
            console.error("Errore durante il fetch delle fatture!", error);
        } finally {
            setLoading(false);
        }
    };
    
    useEffect(() => {
        fetchFatture();
    }, []);
    
    



useEffect(() => {
    let timer;

    if (loading) {
        setProgress(0); 
            timer = setInterval(() => {
            setProgress((prevProgress) => {
                if (prevProgress >= 100) {
                clearInterval(timer); 
                setLoading(false); 
                return 100;
                }
            return prevProgress + 10; 
            });
        }, 300); 
    }

    return () => clearInterval(timer);
}, [loading]);


useEffect(() => {
    if (maxQty !== null) {
        setProducts((prevProducts) =>
            prevProducts.map((product) => ({
                ...product,
                quantita: Math.min(product.quantita, maxQty).toString(), 
            }))
        );
    }
}, [maxQty]);


    // const handleInputChange = (input) => {
    //     setFormValues({
    //         ...formValues,
    //         ...input,
    //     });
    //     setErrors({
    //         ...errors,
    //         ...Object.keys(input).reduce((acc, key) => {
    //             if (input[key] === '') {
    //                 acc[key] = 'Questo campo è obbligatorio';
    //             } else {
    //                 delete errors[key];
    //             }
    //             return acc;
    //         }, {}),
    //     });
    // };


    const handleInputChange = (input) => {
        const updatedValues = {
            ...formValues,
            ...input,
        };
    
        if (input.quantita) {
            const quantitaValue = parseInt(input.quantita, 10);
            const maxAllowedQty = maxQty || Infinity;
    
            if (quantitaValue > maxAllowedQty) {
                setAlert({
                    open: true,
                    message: t("La quantità non può essere superiore a {{maxAllowedQty}}.", { maxAllowedQty }),
                    severity: "error",
                });
                updatedValues.quantita = maxAllowedQty.toString();
            } else if (quantitaValue <= 0) {
                setAlert({
                    open: true,
                    message: t("La quantità deve essere maggiore di 0."),
                    severity: "error",
                });
                updatedValues.quantita = "1";
            }
        }
    
        setFormValues(updatedValues);
    
        setErrors({
            ...errors,
            ...Object.keys(input).reduce((acc, key) => {
                if (input[key] === '') {
                    acc[key] = 'Questo campo è obbligatorio';
                } else {
                    delete errors[key];
                }
                return acc;
            }, {}),
        });
    };
    

    const handleDateChange = (input) => {
        const selectedDate = dayjs(input.dataRicezioneMerce, "DD/MM/YYYY");
        const invoiceDate = dayjs(formValues.dataFattura, "DD/MM/YYYY");
        const diffDays = selectedDate.diff(invoiceDate, 'day');
        if (diffDays > 7) {
        setAlert({
            open: true,
            message: t("Non possiamo elaborare la vostra richiesta. Come indicato nei nostri termini e condizioni, possiamo accettare richieste fino a 7 giorni dalla ricezione merce."),
            severity: "error",
        });
        setFormValues((prevValues) => ({
            ...prevValues,
            dataRicezioneMerce: null, 
        }));
        setIsDataRicezioneEnabled(false);
            return; 
        }

        setFormValues((prevValues) => ({
            ...prevValues,
            dataRicezioneMerce: input.dataRicezioneMerce,
        }));
    };


        useEffect(() => {
            if (formValues.dataRicezioneMerce === '') {
            setFormValues((prevValues) => ({
                ...prevValues,
                dataRicezioneMerce: null, 
            }));
            }
        }, [formValues.dataRicezioneMerce]);


    const handleFilesAdded = (files) => {
        setUploadedFiles(files);
    };

    // const validateFields = (values, products, mandatoryFields) => {
    //     let errors = {};
    
    //     if (radioValue === "nonRicevuta") {
    //         mandatoryFields.forEach((field) => {
    //             if (!values[field]) {
    //                 errors[field] = t("Questo campo è obbligatorio");
    //             }
    //         });
    //     }
    
    //     if (radioValue === "merceDifferente") {
    //         const invalidProducts = products.some(
    //             (product) =>
    //                 !product.skuEan || !product.descrizione || !product.quantita || !product.imei
    //         );
    
    //         if (invalidProducts) {
    //             errors["products"] = t(
    //                 "Devi compilare tutti i campi SKU, Descrizione, Quantità e IMEI per ogni prodotto."
    //             );
    //         }
    //             ["numeroFattura", "dataRicezioneMerce"].forEach((field) => {
    //             if (!values[field]) {
    //                 errors[field] = t("Questo campo è obbligatorio");
    //             }
    //         });
    //     }    
    //     return errors;
    // };


    const validateFields = (values, products, mandatoryFields) => {
        let errors = {};
    
        if (Array.isArray(mandatoryFields)) {
            mandatoryFields.forEach((field) => {
                if (!values[field]) {
                    errors[field] = t("Questo campo è obbligatorio");
                }
            });
        }
    
        // if (radioValue === "merceDifferente") {
        //     const invalidProducts = products.some(
        //         (product) =>
        //             !product.skuEan || !product.descrizione || !product.quantita || !product.imei
        //     );
    
        //     if (invalidProducts) {
        //         errors["products"] = t(
        //             "Devi compilare tutti i campi SKU, Descrizione, Quantità e IMEI per ogni prodotto."
        //         );
        //     }
    
        //     const additionalFields = ["numeroFattura", "dataRicezioneMerce"];
        //     additionalFields.forEach((field) => {
        //         if (!values[field]) {
        //             errors[field] = t("Questo campo è obbligatorio");
        //         }
        //     });
        // }
        // Validazione dei prodotti se "merceDifferente"
    if (radioValue === "merceDifferente") {
        products.forEach((product, index) => {
            if (!product.skuEan || !product.descrizione || !product.quantita || !product.imeiSerial) {
                errors[`products[${index}]`] = t(
                    "Devi compilare tutti i campi SKU, Descrizione, Quantità e IMEI per ogni prodotto."
                );
            }
        });
    }
        return errors;
    };
    
    
    const handleResetFileNames = () => {
        setUploadedFiles([]); 
    };

    const campiObbligatori =
    radioValue === "nonRicevuta"
        ? ["numeroFattura", "skuEan", "dataRicezioneMerce", "quantita", "descrizione"]
        : ["numeroFattura", "dataRicezioneMerce", ]; 

    const fields = [
        { label: t('Numero della fattura'),        name: 'numeroFattura',          type: 'select', options: fattureOptions, disabled: false                 },
        { label: t('Data ricezione merce'),        name: 'dataRicezioneMerce',     type: 'date',                            disabled: !isFatturaSelected    },
        { label: t('SKU/EAN del prodotto'),        name: 'skuEan',                 type: 'select', options: skuOptions,     disabled: !isFatturaSelected    },
        { label: t('Quantità'),                    name: 'quantita',               type: 'number', maxLength: 20,           disabled: !isFatturaSelected    },
        { label: t('Descrizione del prodotto'),    name: 'descrizione',            type: 'note', multiline: true, rows: 4,  disabled: true                  },
        { label: t('Info aggiuntive'),             name: 'infoAggiuntive',         type: 'note', multiline: true, rows: 4,  disabled: !isFatturaSelected    }
    ];


    const productFields = [
        {
            label: t('SKU/EAN del prodotto'),
            name: 'skuEan',
            type: 'select',
            options: skuOptions,
            disabled: !isFatturaSelected,
        },
        {
            label: t('Quantità'),
            name: 'quantita',
            type: 'number',
            maxLength: 20,
            disabled: !isFatturaSelected || isFetchingFatturaDetails,
        },
        {
            label: t('Descrizione del prodotto'),
            name: 'descrizione',
            type: 'note',
            multiline: true,
            rows: 4,
            disabled: true,
        },
        {
            label: t('IMEI o Serial Number'),
            name: 'imeiSerial',
            type: 'imei',
            rows: 4,
            disabled: !isFatturaSelected || isFetchingFatturaDetails,
        },
    ];


    const renderProductFields = (field, index) => {
        switch (field.type) {
            case 'select':
                return (
                    <CustomAutocomplete
                        key={field.name}
                        name={`skuEan_${index}`}
                        label={field.label}
                        options={field.options || []}
                        value={products[index][field.name] || null}
                        onChange={(fieldValue) => {
                            const selectedValue = fieldValue ? Object.values(fieldValue)[0] : "";                            
                            handleProductChange(index, field.name, selectedValue);
                        }}
                        getOptionLabel={(option) => option.label || ""}
                        isOptionEqualToValue={(option, value) => option.value === value}
                        disabled={field.disabled}
                    />

                );
            case 'number':
                return (
                    // <CustomNumber2
                    //     key={field.name}
                    //     name={field.name}
                    //     label={field.label}
                    //     value={products[index][field.name]?.toString() || ""} 
                    //     // onChange={(input) => handleProductChange(index, field.name, input)}
                    //     onChange={(input) => {
                    //         const quantitaValue = parseInt(input.quantita, 10);
                    //         if (quantitaValue > maxQty) {
                    //             setAlert({
                    //                 open: true,
                    //                 message: t("La quantità non può essere superiore a {{maxQty}}.", { maxQty }),
                    //                 severity: "error",
                    //             });
                    //         } else if (quantitaValue <= 0) {
                    //             setAlert({
                    //                 open: true,
                    //                 message: t("La quantità deve essere maggiore di 0."),
                    //                 severity: "error",
                    //             });
                    //             input.quantita = "1";
                    //         }
                    //         handleInputChange(input);
                    //     }}
                    //     maxLength={field.maxLength}
                    //     disabled={field.disabled}
                    // />

               <CustomNumber2
                key={field.name}
                name={field.name}
                label={field.label}
                value={products[index][field.name]?.toString() || ""}
                onChange={(val) => handleProductChange(index, field.name, val)}
                onBlur={() => {
                    const value = products[index].quantita;
                    const maxAllowedQty = products[index].maxQty || maxQty || Infinity;
                    const numericValue = parseInt(value, 10);

                    if (!value || isNaN(numericValue) || numericValue < 1) {
                        handleProductChange(index, "quantita", "1");
                        setAlert({
                            open: true,
                            message: t("La quantità minima consentita è 1. È stata impostata a 1."),
                            severity: "error",
                        });
                    } else if (numericValue > maxAllowedQty) {
                        handleProductChange(index, "quantita", maxAllowedQty.toString());
                        setAlert({
                            open: true,
                            message: t("La quantità non può superare il massimo di {{maxAllowedQty}}. È stata impostata a {{maxAllowedQty}}.", { maxAllowedQty }),
                            severity: "error",
                        });
                    }
                }}
                maxLength={field.maxLength}
                disabled={field.disabled}
            />

                );
            case 'note':
                return (
                    <CustomTextFieldAggiungi
                        key={field.name}
                        name={field.name}
                        label={field.label}
                        values={products[index]}
                        rows={field.rows}
                        disabled={field.disabled}
                    />
                );
                case 'imei':
                return (
                    <CustomTextFieldAggiungi2
                    key={`${field.name}_${index}`}
                    name={field.name}
                    label={field.label}
                    type="text"
                    values={products} 
                    onChange={handleProductChange} 
                    index={index} 
                    disabled={field.disabled}
                    />
                );
            default:
                return null;
        }
    };


    const addProductField = () => {
        const newProduct = { skuEan: '', descrizione: '', quantita: '1', imeiSerial: '' };
        const updatedProducts = [...products, newProduct];
    
        setProducts(updatedProducts);
        setFormValues((prevValues) => ({
            ...prevValues,
            prodotti: updatedProducts.map((product) => ({
                skuEan: product.skuEan,
                descrizione: product.descrizione,
                quantita: product.quantita,
                imeiSerial: product.imeiSerial
            })),
        }));
    };
    
    const removeProductField = (index) => {
        const updatedProducts = products.filter((_, i) => i !== index);
    
        setProducts(updatedProducts);
        setFormValues((prevValues) => ({
            ...prevValues,
            prodotti: updatedProducts.map((product) => ({
                skuEan: product.skuEan,
                descrizione: product.descrizione,
                quantita: product.quantita,
                imeiSerial: product.imeiSerial
            })),
        }));
    };
    

    const handleProductChange = (index, field, value) => {
        const updatedProducts = [...products];
    
        updatedProducts[index][field] = value;
    
        if (field === "skuEan") {
            const matchingSkuDetails = skuDetails.find((item) => item.SKU === value);
    
            if (matchingSkuDetails) {
                const qty = matchingSkuDetails.Qty || 1;
                setMaxQty(qty); 
                updatedProducts[index].descrizione = matchingSkuDetails.Description || "";
                updatedProducts[index].quantita = matchingSkuDetails.Qty > 0 ? "1" : "0";
            } else {
                updatedProducts[index].descrizione = "";
                updatedProducts[index].quantita = "";
            }
        }
    
 if (field === "quantita") {
        const maxAllowedQty = parseInt(updatedProducts[index].maxQty, 10) || Infinity;

        const numericValue = parseInt(value, 10);


        if (numericValue < 1) {
            updatedProducts[index].quantita = "1";
            setAlert({
                open: true,
                message: t("La quantità minima consentita è 1. È stata impostata a 1."),
                severity: "error",
            });
        } else if (numericValue > maxAllowedQty) {
            updatedProducts[index].quantita = maxAllowedQty.toString();
            setAlert({
                open: true,
                message: t("La quantità non può essere superiore a {{maxAllowedQty}}. È stata impostata a {{maxAllowedQty}}.", { maxAllowedQty }),
                severity: "error",
            });
        } else {
            updatedProducts[index].quantita = value;
        }
    }

        if (field === "imeiSerial") {
            updatedProducts[index].imeiSerial = value; 
        }
        setProducts(updatedProducts);
    };
    
    
    const isValidDeliveryDate = (date) => {
        return date && date !== "0";
    };

    
    

    const handleFatturaChange = async (fieldValue) => {
        const numeroFattura = fieldValue.numeroFattura;
    
        if (!numeroFattura) {
            setFormValues((prevValues) => ({
                ...prevValues,
                numeroFattura: '',
                dataFattura: null,
                numeroFatturaReal: null,
            }));
            setIsDataRicezioneEnabled(false);
            setSkuOptions([]);
            setIsFatturaSelected(false); // Disabilita i campi
            return;
        }
    
        const selectedFattura = fattureOptions.find(
            (fattura) => fattura.value === numeroFattura
        );
    
        if (selectedFattura) {
            const dataFatturaEstratta = selectedFattura.label.split(" - ")[1];
            const dataFatturaDayjs = dayjs(dataFatturaEstratta, "DD/MM/YYYY");
            const diffDays = dayjs().diff(dataFatturaDayjs, "day");
    
            if (diffDays > 7) {
                setAlert({
                    open: true,
                    message: t(
                        "Non possiamo accettare fatture di oltre 7 giorni rispetto alla data corrente. Si prega di selezionare una fattura valida."
                    ),
                    severity: "error",
                });
    
                setFormValues((prevValues) => ({
                    ...prevValues,
                    numeroFattura: '', 
                    dataFattura: null,
                    numeroFatturaReal: null,
                    skuEan: null, 
                    descrizione: null,
                    quantita: '1',
                }));
                setSkuOptions([]); 
                setIsDataRicezioneEnabled(false); 
                setIsFatturaSelected(false); 
                return; 
            }
    
            setFormValues((prevValues) => ({
                ...prevValues,
                numeroFattura: numeroFattura,
                dataFattura: dataFatturaEstratta,
                numeroFatturaReal: selectedFattura.label.split(" - ")[0],
            }));
    
            setDataFattura(dataFatturaEstratta);
            setIsDataRicezioneEnabled(true);
            setIsFatturaSelected(true);
        }
    
        try {
            const response = await axios.get(
                `/cliente/riba/dati/fattura/${numeroFattura}`,
                { headers: headers }
            );
    
            if (response.data?.code === 200 && Array.isArray(response.data.result)) {
                const fatturaDettagli = response.data.result;
                setSkuDetails(fatturaDettagli);
                const skuOptions = fatturaDettagli.map((item) => ({
                    label: item.SKU,
                    value: item.SKU,
                }));
    
                setSkuOptions(skuOptions);
                const firstItem = fatturaDettagli[0];
                const deliveryDateFormatted = isValidDeliveryDate(firstItem.DeliveryDate)
                    ? dayjs(firstItem.DeliveryDate, "YYYYMMDD").format("DD/MM/YYYY")
                    : null;
    
                setFormValues((prevValues) => ({
                    ...prevValues,
                    dataFattura: deliveryDateFormatted,
                    dataRicezioneMerce: deliveryDateFormatted,
                }));
            } else {
                console.error("La risposta non contiene un array valido in `result`:", response.data);
            }
        } catch (error) {
            console.error("Errore durante il fetch dei dettagli della fattura!", error);
        }
    };
    
    

    const handleSkuChange = (fieldValue) => {
        const matchingSkuDetails = skuDetails.find((item) => item.SKU === fieldValue.skuEan);
        const formatDate = (date) => {
            if (!date) return null; 
            return dayjs(date, "YYYYMMDD").format("DD/MM/YYYY"); 
        };
    
        if (matchingSkuDetails) {
            setMaxQty(matchingSkuDetails.Qty); 
            setFormValues((prevValues) => ({
                ...prevValues,
                skuEan: fieldValue.skuEan,
                descrizione: matchingSkuDetails.Description,
                quantita: matchingSkuDetails.Qty > 0 ? '1' : '',
            }));
        } else {
            setFormValues((prevValues) => ({
                ...prevValues,
                skuEan: fieldValue.skuEan,
                descrizioneProblema: "",
                quantita: '',
            }));
            setMaxQty(0);
        }
    };


    const handleRadioChange = (event) => {
        setRadioValue(event.target.value);
    };
    
    const isDateValid = formValues.dataRicezioneMerce && formValues.dataRicezioneMerce !== "0";

    

    const renderFields = (field) => {
        const { name, label, type, ...otherProps } = field;

        switch (type) {
            case 'text':
                return (
                    <CustomTextFieldAggiungi
                        key={name}
                        name={name}
                        label={label}
                        values={formValues}
                        onChange={handleInputChange}
                        {...otherProps}
                    />
                );
                case 'date':
                
                    return isDateValid ? (
                        <TextField
                            key={name}
                            label={t("Data ricezione merce")}
                            value={formValues.dataRicezioneMerce}
                            InputProps={{ readOnly: true }}
                            disabled
                            fullWidth
                            sx={{
                                backgroundColor: "transparent",
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": { borderColor: "#fda03d" },
                                },
                                "& .Mui-disabled": {
                                    cursor: "not-allowed",
                                },
                                "& .MuiInputLabel-root.Mui-focused": {
                                    color: "#fda03d",
                                },
                            }}
                        />
                    ) : (
                        <CustomDatePickerAggiungi
                            key={name}
                            name="dataRicezioneMerce"
                            label={t("Data ricezione merce")}
                            values={formValues}
                            onChange={(input) => {
                                handleDateChange(input);
                                setFormValues((prev) => ({ ...prev, dataRicezioneMerce: input.dataRicezioneMerce }));
                            }}
                            disabled={!isDataRicezioneEnabled}
                            {...otherProps}
                        />
                    );
                
                
            case 'note':
                return (
                    <CustomNoteAggiungi
                        key={name}
                        name={name}
                        label={label}
                        values={formValues}
                        onChange={handleInputChange}
                        {...otherProps}
                    />
                );
                case 'number':
                    return (
                        <CustomNumberAggiunta
                            key="quantita"
                            name="quantita"
                            label={t("Quantità (pezzi)")}
                            values={formValues}
                            onChange={(input) => {
                                setFormValues((prevValues) => ({
                                ...prevValues,
                                quantita: input.quantita,
                                }));
                            }}
                            onBlur={() => {
                                const value = Number(formValues[name]);

                                if (value < 1) {
                                    setFormValues((prevValues) => ({
                                        ...prevValues,
                                        [name]: 1,
                                    }));
                                    setAlert({
                                        open: true,
                                        message: t('La quantità minima consentita è 1. È stata impostata a 1.'),
                                        severity: 'error'
                                    });
                                } else if (value > maxQty) {
                                    setFormValues((prevValues) => ({
                                        ...prevValues,
                                        [name]: 1,
                                    }));
                                    setAlert({
                                        open: true,
                                        message: t('La quantità non può superare il massimo di {{maxQty}}. È stata impostata a 1.', { maxQty }),
                                        severity: 'error'
                                    });
                                }
                            }}
                            maxLength={3}
                            maxQty={maxQty} 
                            setAlert={setAlert} 
                            {...otherProps}
                            />
                    );
            case 'select':
                return (
                    <CustomAutocomplete
                        name={field.name}
                        label={field.label}
                        options={field.options || []}
                        value={formValues[field.name] || null}
                        onChange={(fieldValue) => {
                            if (name === "numeroFattura") handleFatturaChange(fieldValue);
                            if (name === "skuEan") handleSkuChange(fieldValue);
                            setFormValues((prev) => ({ ...prev, ...fieldValue }));
                        }}
                        getOptionSelected={(option, value) => option.value === value.value}
                        {...otherProps}
                    />
                );
            default:
                return null;
        }
    };



    const handleSubmit = async () => {
    const hasInvalidQuantita = !formValues.prodotti.every(p => p.quantita && !isNaN(p.quantita) && parseInt(p.quantita, 10) > 0);

    if (hasInvalidQuantita) {
        setAlert({
            open: true,
            message: t("Ogni prodotto deve avere una quantità valida (maggiore di zero)."),
            severity: "error"
        });
        return;
    }
        try {
            const validationErrors = validateFields(formValues, products, campiObbligatori);
            if (Object.keys(validationErrors).length > 0) {
                setErrors(validationErrors);
                return;
            }

            let prodottiToSend = [];

            if (radioValue === "nonRicevuta") {
                prodottiToSend = [{
                    skuEan: formValues.skuEan || "",
                    descrizione: formValues.descrizione || "",
                    quantita: formValues.quantita || "1",
                    imeiSerial: null, 
                }];
            } else if (radioValue === "merceDifferente") {
                prodottiToSend = products.map((product) => ({
                    skuEan: product.skuEan,
                    descrizione: product.descrizione,
                    quantita: product.quantita,
                    imeiSerial: product.imeiSerial,
                }));
            }
    
            const { skuEan, quantita, descrizione, imeiSerial, ...newFormValues } = formValues;
    
            const datiDaInviare = {
                ...newFormValues,
                prodotti: prodottiToSend,
            };

    
            // const response = await axios.post(`http://localhost:8080/rma/salva/${idCliente}`, datiDaInviare, { headers: headers });
            const response = await ApiService.request("rmaClienteSave", {IDCustomerRMT: IDCustomerRMT}, datiDaInviare);

            if (response.status === 200) {

            
            const id = response.data;

            try {
                if (uploadedFiles.length > 0) {
                    const formDataIMG = new FormData();
                    uploadedFiles.forEach(file => formDataIMG.append("file", file));
                    // const responseFile = await axios.post(`http://localhost:8080/rma/salva/file/${id}`, formDataIMG, {
                    //     headers: {
                    //         "Content-Type": "multipart/form-data",
                    //         Authorization: `Bearer ${token}`,
                    //     }
                    // });
                    const responseFile = await ApiService.request("fileSave", { id: id}, formDataIMG, { "Content-Type": "multipart/form-data" })
                    
                } else {
                    // const responseNullFile = await axios.post(`http://localhost:8080/rma/salva/file/${id}`, null, {
                    //     headers: {
                    //         "Content-Type": "application/json",
                    //         Authorization: `Bearer ${token}`,
                    //     }
                    // });
                    const responseFile = await ApiService.request("fileSave", { id: id}, null, { "Content-Type": "multipart/form-data" })
                    
                }
            setAlert({ open: true, message: t('Reso inviato con successo!'), severity: 'success' });

            setTimeout(() => setAlert({ ...alert, open: false }), 6000);  
            setFormValues({}); 
            // const responseRMACreata = await axios.get(`http://localhost:8080/rma/${id}`, { headers: headers});
            const responseRMACreata = await ApiService.request("getRmaID", { idRma: id});
            
            const idReso = responseRMACreata.data?.idReso;
            
            if(idReso) {
            handleSendEmailAvviso(idReso);
            }     
            setTimeout(() => {
                window.history.back();
            }, 1000); 

        } catch (error) {
            setAlert({ open: true, message: t('Errore durante l\'invio del reso.'), severity: 'error' });
            setTimeout(() => setAlert({ ...alert, open: false }), 6000);
        }   
    }     
        } catch (error) {
            setAlert({ open: true, message: t('Errore durante l\'invio del reso.'), severity: 'error' });
            setTimeout(() => setAlert({ ...alert, open: false }), 6000);      
            console.error("errore durante l'invio dei dati: ", error);       
        }
    };

    const handleBackClick = () => {
        if (step === 2) {
            setStep(1);
        } else {
            navigate(-1);
        }
    };


    const handleSendEmailAvviso = (idReso) => {
        const idResoDaInviare = idReso
        const destinatario = 'andrearizza6@gmail.com'
        const idDestinatario = 1 
        const messaggio = t('Creazione nuovo RMA tipo Merce non conforme') + ` #${idResoDaInviare} ` + t('da parte di') + ` ${ragioneSociale}`;
        const messaggioCreazioneRMA = null;

        /* invio email */
        // SendEmail(
        //     idResoDaInviare,
        //     destinatario,
        //     messaggio,
        //     'NUOVA_RMA',
        //     () => {
        //         setMessage(t('Email di contatto inviata con successo!'));
        //         setSnackbarSeverity('success');
        //     },
        //     () => {
        //         setMessage(t("Errore nell'invio dell'email. Per favore, riprova."));
        //         setSnackbarSeverity('error');
        //     }
        // );

        // SendEmail(
        //     idResoDaInviare,
        //     destinatario,
        //     messaggioCreazioneRMA,
        //     'CREAZIONE_RMA',
        //     () => {
        //         setMessage(t('Email di contatto inviata con successo!'));
        //         setSnackbarSeverity('success');
        //     },
        //     () => {
        //         setMessage(t("Errore nell'invio dell'email. Per favore, riprova."));
        //         setSnackbarSeverity('error');
        //     }
        // );

        // Invio avviso
        SendAvviso(
            idResoDaInviare,
            idDestinatario,
            'NUOVA_RMA',

            () => {
                setMessage(t('Avviso inviato al cliente con successo!'));
                setSnackbarSeverity('success');
            },
            () => {
                setMessage(t("Errore nell'invio dell'avviso. Per favore, riprova."));
                setSnackbarSeverity('error');
            }
        )
    };


    // Funzione per la validazione dei campi obbligatori e dei file
    const validateForm = () => {
        const mandatoryFields = radioValue === "nonRicevuta"
            ? ["numeroFattura", "skuEan", "dataRicezioneMerce", "quantita", "descrizione"]
            : ["numeroFattura", "dataRicezioneMerce"]; 
    
        const fieldErrors = validateFields(formValues, products, mandatoryFields);
        const hasFiles = uploadedFiles.length > 0;
    
        const isValid = Object.keys(fieldErrors).length === 0 && hasFiles;
        return isValid;
    };
    

    

    return (
        <ResiFormLayout
            color1="#952828"
            color2="#FD6D3D"
            icon={<Box component="img" src={MerceNonConforme} alt="Merce Danneggiata" sx={{ width: 40, height: 40 }} />}
            title={t("Ricevuta merce non conforme all'ordine")}
            onBackClick={handleBackClick}
        >
            <form>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 4
                }}>
                    
                    <Grid container spacing={2}>
                           {/* Radio button per la scelta */}
                    <Grid item xs={12}>
                    <Box sx={{ maxHeight: "80vh", overflowY: "auto", padding: "20px" }}>

            {/* Radio buttons */}
            <FormControl component="fieldset">
                <FormLabel component="legend"></FormLabel>
                <RadioGroup row name="motivoRichiesta" value={radioValue} onChange={handleRadioChange} >
                    <FormControlLabel
                        value="nonRicevuta"
                        control={<Radio  />}
                        label={t("Non ho ricevuto questa merce")}
                        />
                    <FormControlLabel
                        value="merceDifferente"
                        control={<Radio />}
                        label={t("Ho ricevuto merce differente da quella ordinata")}
                        />
                </RadioGroup>
            </FormControl>

            {/* Campi aggiuntivi per "Ho ricevuto merce differente da quella ordinata" */}
            {radioValue === "merceDifferente" && (
                <>
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 4}}>
                <CustomAutocomplete
                name="numeroFattura"
                label={t('Numero della fattura')}
                options={fattureOptions}
                value={formValues.numeroFattura || null}
                onChange={(fieldValue) => {
                    handleFatturaChange(fieldValue);
                    setFormValues((prev) => ({ ...prev, ...fieldValue }));
                }}
                disabled={false}
            />
            {isDateValid ? (
                <TextField
                    name="dataRicezioneMerce"
                    label={t("Data ricezione merce")}
                    value={formValues.dataRicezioneMerce}
                    InputProps={{ readOnly: true }}
                    disabled
                    fullWidth
                    sx={{
                        backgroundColor: "transparent",
                        "& .MuiOutlinedInput-root": {
                            "& fieldset": { borderColor: "#fda03d" },
                        },
                        "& .Mui-disabled": {
                            cursor: "not-allowed",
                        },
                        "& .MuiInputLabel-root.Mui-focused": {
                            color: "#fda03d",
                        },
                    }}
                />
            ) : (
                <CustomDatePickerAggiungi
                    name="dataRicezioneMerce"
                    label={t('Data ricezione merce')}
                    values={formValues}
                    onChange={(input) => {
                        handleDateChange(input);
                        setFormValues((prev) => ({ ...prev, dataRicezioneMerce: input.dataRicezioneMerce }));
                    }}
                    disabled={!isFatturaSelected}
                />
            )}
            </Box>
                
                <Box sx={{ mt: 3, width: '100%' }}>
                            <Typography variant="h6" gutterBottom>
                                {t('Prodotti')}
                            </Typography>
                            {products.map((product, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        border: "1px solid #ccc",
                                        borderRadius: "8px",
                                        padding: "16px",
                                        marginBottom: "16px",
                                        position: "relative",
                                    }}
                                >
                                    <Grid container spacing={2}>
                                        {productFields.map((field) => (
                                            <Grid item xs={12} sm={6} key={field.name}>
                                                {renderProductFields(field, index)}
                                            </Grid>
                                        ))}
                                    </Grid>
                                    {products.length > 1 && (
                                        <IconButton
                                            sx={{ position: "absolute", top: "8px", right: "8px" }}
                                            onClick={() => removeProductField(index)}
                                        >
                                            <RemoveCircleIcon color="error" />
                                        </IconButton>
                                    )}
                                </Box>
                            ))}
                            <Button
                                startIcon={<AddCircleIcon />}
                                variant="outlined"
                                onClick={addProductField}
                                disabled={
                                    !products[products.length - 1].skuEan ||
                                    !products[products.length - 1].descrizione ||
                                    !products[products.length - 1].quantita
                                }
                                sx={{
                                    mt: 2,
                                    borderColor: "#fda03d",
                                    color: "#fda03d",
                                    "&:hover": {
                                        transform: "scale(1.01)",
                                    },
                                }}
                            >
                                {t('Aggiungi Prodotto')}
                            </Button>
                        </Box>
                        </>
            )}
        </Box>
        
                    </Grid>
                    {radioValue === "nonRicevuta" && (
                        <>
                        {fields.map((field) => (
                            <Grid
                                item
                                xs={12}
                                sm={field.type === 'note' ? 12 : 6}
                                key={field.name}
                            >
                                {renderFields(field)}
                            </Grid>
                        ))}
                        </>
                    )}


                        <Grid item xs={12}>
                            <Typography sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 2 }}>
                                {t('foto e/o video a dimostrazione di quanto riportato')}
                            </Typography>
                            <CustomDragAndDrop
                                id="fileInputMerceNonConforme"
                                onFilesAdded={handleFilesAdded}
                                enabled={true}
                                onResetFiles={handleResetFileNames}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Button
                                onClick={() => handleSubmit(formValues)}
                                variant="contained"
                                sx={{
                                    mt: 3,
                                    width: '150px',
                                    background: validateForm() ? 'linear-gradient(135deg, #952828, #FD6D3D)' : 'gray',
                                    boxShadow: "10px 10px 10px rgba(0, 0, 0, 0.1)",
                                    borderRadius: '10px',
                                    "&:hover": {
                                        background: validateForm() ? 'linear-gradient(135deg, #952828, #FD6D3D)' : 'gray',
                                        transform: validateForm() ? 'scale(1.05)' : 'none',
                                    }
                                }}
                                disabled={!validateForm()}
                            >
                                {t('Invia')}
                            </Button>

                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </form>
            {alert.open && (
                <Alert severity={alert.severity} onClose={() => setAlert({ ...alert, open: false })}
                sx={{
                    position: 'fixed',
                    top: 20, 
                    left: '50%',
                    transform: 'translateX(-50%)', 
                    zIndex: 9999, 
                    minWidth: '300px',
                    maxWidth: '600px',
                }}
                >
                    {alert.message}
                </Alert>
            )} 
            {/* Loader al centro */}
            {(loading || isFetchingFatturaDetails) &&  (
                <Box
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: 'rgba(217, 217, 217, 0.56)',
                    zIndex: 9999,
                }}
                >
                <CircularProgressWithLabel value={progress} />
                </Box>
            )}
        </ResiFormLayout>
    );
};

export default MerceNonConformeForm;
